module.exports = __webpack_public_path__ + "c78b84d58ded58fa761afe73186c9c93.png";